<script setup lang="ts">
</script>

<template>
  <main class="text-slate-900" style="min-height: 100vh;">
    <router-view/>
  </main>
</template>
